import { pessoaModel } from '@/models/pessoa'

export const detentoraModel = {
  detentora: function () {
    return {
      pessoa_id: '',
      pessoa: new pessoaModel.pessoa(),
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Detentora/_model/detentora.js